import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"position":"absolute","top":"0px","left":"20px","font-size":"11px","font-weight":"normal","opacity":"0.6"} }
const _hoisted_2 = { style: {"font-size":"14px","font-weight":"normal","line-height":"1","margin":"0","white-space":"nowrap"} }
const _hoisted_3 = { class: "d-flex align-center mr-2" }
const _hoisted_4 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_5 = { style: {"position":"relative","display":"inline-block"} }
const _hoisted_6 = { style: {"position":"absolute","top":"0px","left":"20px","font-size":"11px","font-weight":"normal","opacity":"0.6"} }
const _hoisted_7 = { style: {"font-size":"14px","font-weight":"normal","line-height":"1","margin":"0","white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_subheader = _resolveComponent("v-list-subheader")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated && _ctx.model && _ctx.models && _ctx.models.length > 1)
      ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
          activator: _withCtx(({ props: menuProps }) => [
            _createVNode(_component_v_tooltip, {
              location: "bottom",
              "open-delay": "250",
              "open-on-hover": true
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createElementVNode("div", _mergeProps(_ctx.mergeProps(menuProps, tooltipProps), {
                  class: "tbdc-dropdownmenu",
                  style: {"padding":"15px 20px 8px 20px","flex":"none","position":"relative","cursor":"pointer"}
                }), [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("message.model")), 1),
                  _createElementVNode("h3", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_ctx.splitModelName(_ctx.model.name).title) + " ", 1),
                    (_ctx.splitModelName(_ctx.model.name).version)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          size: "x-small",
                          color: "teal lighten-5",
                          "text-color": "teal darken-3",
                          class: "pl-2 pr-2"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("v" + _toDisplayString(_ctx.splitModelName(_ctx.model.name).version), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ], 16)
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.model")), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              class: "overflow-y-auto",
              style: {"max-height":"95vh"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedModels, (model) => {
                  return (_openBlock(), _createBlock(_component_v_list_item, {
                    key: model.id,
                    onClick: ($event: any) => {_ctx.setModel(model);}
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-domain", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.splitModelName(model.name).title), 1),
                          (_ctx.splitModelName(model.name).version)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                size: "x-small",
                                color: "teal lighten-5",
                                "text-color": "teal darken-3",
                                class: "ml-auto pl-2 pr-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("v" + _toDisplayString(_ctx.splitModelName(model.name).version), 1)
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated && _ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Owner'))
      ? (_openBlock(), _createBlock(_component_v_menu, { key: 1 }, {
          activator: _withCtx(({ props: menuProps }) => [
            _createVNode(_component_v_tooltip, {
              location: "bottom",
              "open-delay": "250",
              "open-on-hover": true
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_v_btn, _mergeProps({
                    icon: "",
                    variant: "text"
                  }, _ctx.mergeProps(menuProps, tooltipProps), { style: {"height":"36px","width":"36px"} }), {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("mdi-menu", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 16),
                  _createVNode(_component_v_icon, {
                    size: "10",
                    style: {"position":"absolute","right":"-2px","bottom":"-1px","opacity":"0.55","pointer-events":"none"}
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-lock-outline", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.modelAdmin")) + " (" + _toDisplayString(_ctx.$t("message.ownerOnly")) + ")", 1)
              ]),
              _: 2
            }, 1024)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_subheader, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("message.modelAdmin")), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, { onClick: _ctx.fetchModelParameters }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_action, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-wrench", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.editModelParameters")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_list_item, { onClick: _ctx.fetchNormalizedScoresFunctions }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_action, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-wrench", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.editNormalizedScoresFunctions")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_list_item, { onClick: _ctx.fetchDrivers }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_action, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode("mdi-wrench", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.editDrivers")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_list_item, { onClick: _ctx.openNCalcTester }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_action, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createTextVNode("mdi-calculator-variant-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                          _createTextVNode("NCALC", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_list_item, { onClick: _ctx.fetchModelAccess }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_action, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                            _createTextVNode("mdi-account-multiple-check-outline", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("message.whoHasAccess")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_divider),
                _createVNode(_component_v_list_item, { onClick: _ctx.toggleModelSort }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_action, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.sortByCreatedDesc ? 'mdi-sort-calendar-descending' : 'mdi-sort-alphabetical-ascending'), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", null, [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.sortByCreatedDesc ? _ctx.$t("message.sortModelsAlphabetic") : _ctx.$t("message.sortModelsByCreatedDesc")), 1)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated && ((_ctx.model && _ctx.models && _ctx.models.length > 1) || (_ctx.getModel && _ctx.getModel.roles && _ctx.getModel.roles.includes('Owner'))))
      ? (_openBlock(), _createBlock(_component_v_divider, {
          key: 2,
          class: "ml-2 mr-2",
          vertical: ""
        }))
      : _createCommentVNode("", true),
    (_ctx.isAuthenticated && _ctx.subModel && _ctx.subModels && _ctx.subModels.length > 1)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          _createVNode(_component_v_menu, null, {
            activator: _withCtx(({ props: menuProps }) => [
              _createVNode(_component_v_tooltip, {
                location: "bottom",
                "open-delay": "250",
                "open-on-hover": true
              }, {
                activator: _withCtx(({ props: tooltipProps }) => [
                  _createElementVNode("div", _mergeProps(_ctx.mergeProps(menuProps, tooltipProps), {
                    class: "tbdc-dropdownmenu",
                    style: {"padding":"15px 20px 8px 20px","flex":"none","position":"relative","cursor":"pointer"}
                  }), [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("message.submodel")), 1),
                    _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.subModel.name), 1)
                  ], 16)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("message.submodel")), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, {
                class: "overflow-y-auto",
                style: {"max-height":"95vh"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subModels, (subModel) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: subModel.id,
                      onClick: ($event: any) => (_ctx.setSubModel(subModel))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(subModel.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_divider, {
            class: "ml-2 mr-2",
            vertical: ""
          })
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_v_btn, {
      icon: "",
      variant: "text",
      target: "_blank",
      style: {"height":"36px","width":"36px"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadFile({ url: '/api/help/' + _ctx.$i18n.locale,  name: 'IRIS-Help.pdf' })))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("mdi-help-circle", -1)
          ]))]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}